(function () {
  'use strict';

  if (window.ozGestartet) return;
  window.ozGestartet = true;

  var bloecke = document.querySelectorAll('[data-oz]');
  if (!bloecke.length) return;

  function wurzel() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function abruf(url) {
    if (window.EngineStatus) return window.EngineStatus.hol(url);
    return fetch(url).then(function (r) { return r.json(); });
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function auswahl() {
    try { return JSON.parse(localStorage.getItem('3idee_auswahl') || 'null') || {}; }
    catch (e) { return {}; }
  }
  function ohneSchwelle(html) {
    var d = document.createElement('div');
    d.innerHTML = String(html || '');
    var t = (d.textContent || '').replace(/\s*\([^)]*\bkg\)/g, '').replace(/\s+/g, ' ').trim();
    return t.split(/(?<=[.!?])\s+(?=[A-ZÄÖÜ])/).filter(function (s) { return !/\d+\s*kg/.test(s); }).join(' ').trim();
  }

  var merk = {};
  function artikel(handle) {
    if (!handle) return Promise.resolve(null);
    if (merk[handle]) return merk[handle];
    var meta = fetch(wurzel() + 'products/' + encodeURIComponent(handle) + '?view=finder-meta')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    merk[handle] = Promise.all([fetch(wurzel() + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; }), meta])
      .then(function (beide) {
        var p = beide[0], mt = beide[1];
        if (!p) return null;
        var kaufbar = (p.variants || []).filter(function (v) { return v.available; });
        var v = kaufbar[0] || (p.variants || [])[0] || null;
        var alloc = v && v.selling_plan_allocations && v.selling_plan_allocations[0];
        return { titel: p.title || '', bild: p.featured_image || '',
                 preis: v ? v.price / 100 : null, variante: v ? v.id : null,
                 plan: alloc ? alloc.selling_plan_id : null, kaufbar: !!kaufbar.length,
                 rabatt: (mt && mt.rabatt) || null };
      })
      .catch(function () { return null; });
    return merk[handle];
  }

  function rabattEuro(r, preis) {
    if (!r || !(Number(r.wert) > 0) || preis == null) return 0;
    return r.art === 'prozent' ? Math.round(preis * Number(r.wert)) / 100 : Number(r.wert);
  }

  bloecke.forEach(function (block) {
    var liste = block.querySelector('[data-oz-liste]');
    var monitore = [];
    var platte = null;
    var urteil = null;
    var teile = [];
    var aus = {}, an = {};
    var lauf = 0;

    function wort(n, r) { return block.getAttribute('data-oz-wort-' + n) || r || ''; }
    function proxy() {
      return (window.FinderClean && window.FinderClean.proxy)
        || block.getAttribute('data-oz-proxy-fallback') || '/apps/monitor-db';
    }
    function geld(n, ganz) {
      n = Number(n);
      if (!isFinite(n)) return '';
      if (ganz) n = Math.floor(n + 1e-9);
      var st = ganz ? 0 : 2;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'de', {
          style: 'currency', currency: block.getAttribute('data-oz-waehrung') || 'EUR',
          minimumFractionDigits: st, maximumFractionDigits: st }).format(n);
      } catch (e) { return n.toFixed(st).replace('.', ',') + ' €'; }
    }
    function teilName(titel, namen) {
      var kurz = String(titel || '').replace(/\s*\([^)]*\)\s*/g, ' ').trim();
      if (!namen || !namen.length) return kurz;
      var m = kurz.match(/^(.*?)\s+für\s+/i);
      if (m) kurz = m[1];
      return wort('teil-fuer', '@TEIL@ für @GERAETE@').replace('@TEIL@', kurz.trim()).replace('@GERAETE@', namen.join(', '));
    }

    function bauen() {
      var raus = [];
      monitore.forEach(function (m) {
        var n = Number(m.anzahl) || 1;
        var erster = (m.alternativen || [])[0];
        if (erster) {
          var da = raus.filter(function (t) { return t.handle === erster; })[0];
          if (da) { da.anzahl += n; if (m.name && da.geraete.indexOf(m.name) < 0) da.geraete.push(m.name); }
          else raus.push({ handle: erster, stufe: 'REQUIRED', anzahl: n, adapter: true,
                           geraete: m.name ? [m.name] : [], grund: (m.gruende || {})[erster] || '' });
        }
        (m.zubehoer || []).forEach(function (z) {
          if (!z || z.imShop === false || !z.handle) return;
          if (z.stufe !== 'REQUIRED' && z.stufe !== 'RECOMMENDED') return;
          var schon = raus.filter(function (t) { return t.handle === z.handle; })[0];
          if (schon) { schon.anzahl += n; if (z.stufe === 'REQUIRED') schon.stufe = 'REQUIRED'; return; }
          raus.push({ handle: z.handle, stufe: z.stufe, anzahl: n, geraete: [], grund: z.text || '',
                      name: z.name || '', bild: z.bild || '' });
        });
      });
      ((urteil && urteil.requires) || []).forEach(function (r) {
        var n = Number(r.qty) || 1;
        var schon = raus.filter(function (t) { return t.handle === r.handle; })[0];
        if (schon) { schon.stufe = 'REQUIRED'; schon.anzahl = Math.max(schon.anzahl, n); return; }
        raus.push({ handle: r.handle, stufe: 'REQUIRED', anzahl: n, geraete: [], grund: r.reason || '', name: r.name || '' });
      });
      var ohneTisch = block.hasAttribute('data-oz-wand')
        || (urteil && urteil.urteil === 'nein' && (!block.hasAttribute('data-oz-one') || urteil.keinOne));
      if (!ohneTisch && platte && platte.handle && platte.imShop !== false
          && (platte.stufe === 'REQUIRED' || platte.stufe === 'RECOMMENDED')) {
        raus.push({ handle: platte.handle, stufe: platte.stufe, anzahl: 1, geraete: [],
                    grund: platte.text || '', name: platte.name || '' });
      }
      teile = raus;
      raus.forEach(function (t) {
        artikel(t.handle).then(function (a) {
          if (!a || teile.indexOf(t) < 0) return;
          t.preis = a.preis; t.variante = a.variante; t.plan = a.plan; t.kaufbar = a.kaufbar;
          t.titel = a.titel; t.rabatt = a.rabatt; if (!t.bild) t.bild = a.bild;
          zeichnen();
        });
      });
      zeichnen();
    }

    function setupAnzahl() {
      var a = Number(block.getAttribute('data-oz-anzahl')) || 0;
      if (a) return a;
      try {
        var d = JSON.parse((document.querySelector('[data-okf-daten]') || {}).textContent || 'null');
        var k = d && (d.paket.kombinationen || []).filter(function (x) { return x.preset && x.preset === d.eigen; })[0];
        var AN = { single: 1, dual_horizontal: 2, dual_vertical: 2, triple_horizontal: 3, triple_pyramid: 3, quad_grid: 4, quad_pyramid: 4 };
        return (k && (Number(k.monitore) || AN[k.anordnung])) || 0;
      } catch (e) { return 0; }
    }
    function eingegeben() { return monitore.reduce(function (s, m) { return s + (Number(m.anzahl) || 1); }, 0); }
    var ZEILE = block.querySelector('[data-oz-anzahl-zeile]');
    function zeileSetzen() {
      if (!ZEILE || ZEILE.__ozGesetzt) return;
      var seite = konfig ? block.closest('.okf') : block.closest('.product-details');
      var kasten = seite ? seite.querySelector(konfig ? '.fck.okf__arb' : '.fck:not(.okf__arb)') : null;
      if (kasten) kasten.appendChild(ZEILE);
      else {
        var box = block.closest('.okf__zub'), e = block.parentElement;
        for (var i = 0; !box && e && i < 4; i++, e = e.parentElement) {
          if (parseFloat(getComputedStyle(e).borderTopWidth) > 0) box = e;
        }
        if (!box || !box.parentNode) return;
        box.parentNode.insertBefore(ZEILE, box);
        ZEILE.classList.toggle('oz__anzahl--flaeche', !konfig);
      }
      ZEILE.__ozGesetzt = true;
      ZEILE.addEventListener('click', function (ev) {
        var um = ev.target.closest('[data-oz-umstellen]');
        if (um) umstellen(Number(um.getAttribute('data-oz-umstellen')));
      });
    }
    function umstellen(n) {
      var reiter = document.querySelector('[data-okr-r="individuell"]');
      if (reiter && !konfig) reiter.click();
      document.dispatchEvent(new CustomEvent('okf:anzahl', { detail: { n: n } }));
    }
    function anzahlZeile() {
      var z = ZEILE;
      if (!z) return;
      zeileSetzen();
      var n = setupAnzahl(), e = eingegeben();
      if (!n || !e || e === n) { z.hidden = true; z.innerHTML = ''; return; }
      var wege = [];
      if (e < n) wege.push(['setup', wort('weiter')]);
      if (e >= 1 && e <= 4) wege.push(['um', e === 1 ? wort('umstellen-1') : wort('umstellen-n').replace('%n', e)]);
      var knoepfe = wege.map(function (w, i) {
        var txt = i === 0 ? w[1].charAt(0).toUpperCase() + w[1].slice(1) : w[1];
        return '<button type="button" class="oz__weg" ' + (w[0] === 'setup' ? 'data-fenster-auf="setup"' : 'data-oz-umstellen="' + e + '"') + '>' + esc(txt) + '</button>';
      });
      z.innerHTML = esc(n === 1 ? wort('anzahl-1', wort('anzahl').replace('%n', n)) : wort('anzahl').replace('%n', n)) + (knoepfe.length ? ' ' + knoepfe.join(' ' + esc(wort('oder', 'oder')) + ' ') + '.' : '');
      z.hidden = false;
    }
    function bundleJe() {
      var bv = Number(block.getAttribute('data-oz-bundle')) || 0, rest = setupAnzahl() || 99, m = {};
      teile.forEach(function (t) {
        if (!t.adapter || !istAn(t) || !bv || rest <= 0) return;
        var k = Math.min(t.anzahl, rest); rest -= k; m[t.handle] = k * bv;
      });
      return m;
    }

    function zeilenpreis(t, bundle) {
      if (t.preis == null) return '';
      var voll = t.preis * t.anzahl, ab = rabattEuro(t.rabatt, t.preis) * t.anzahl, netto = voll - ab;
      if (bundle > 0) return '<s class="ost__gesamt-alt">' + esc(geld(netto, true)) + '</s> '
        + '<span class="vorteil-etikett vorteil-etikett--kontur oz__bundlepreis">' + esc(geld(Math.max(0, netto - bundle), true)) + '</span>';
      return ab ? '<s class="ost__gesamt-alt">' + esc(geld(voll, true)) + '</s> ' + esc(geld(netto, true)) : esc(geld(voll, true));
    }

    function istAn(t) {
      if (!t.variante || t.kaufbar === false) return false;
      return t.stufe === 'REQUIRED' ? !aus[t.handle] : !!an[t.handle];
    }

    function zeichnen() {
      block.hidden = !teile.length;
      anzahlZeile();
      var bj = bundleJe();
      liste.innerHTML = teile.map(function (t) {
        var pflicht = t.stufe === 'REQUIRED';
        var on = istAn(t);
        var name = t.adapter ? teilName(t.titel || t.name, t.geraete) : (t.titel || t.name || '');
        var grund = ohneSchwelle(t.grund);
        return '<li class="oz__zeile' + (t.variante && t.kaufbar !== false ? '' : ' is-aus') + '" data-oz-teil="' + esc(t.handle) + '">'
          + '<button type="button" class="oz__haken' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" aria-label="' + esc(name) + '"></button>'
          + '<span class="oz__bild">' + (t.bild ? '<img src="' + esc(t.bild) + '" alt="" loading="lazy">' : '') + '</span>'
          + '<span class="oz__txt"><span class="oz__name">' + (t.anzahl > 1 ? esc(t.anzahl) + '× ' : '') + esc(name) + '</span>'
          + '<span class="oz__marken">'
          +   (grund
                ? '<button type="button" class="oz__stufe" data-oz-i data-fenster-auf="oz-regel" aria-label="'
                  + esc(wort('warum', 'Warum?')) + '">' + esc(pflicht ? wort('erforderlich', 'Erforderlich') : wort('empfohlen', 'Empfohlen'))
                  + '<span class="oz__i" aria-hidden="true">i</span></button>'
                : '<span class="oz__stufe">' + esc(pflicht ? wort('erforderlich', 'Erforderlich') : wort('empfohlen', 'Empfohlen')) + '</span>')
          +   (bj[t.handle] ? '<span class="vorteil-etikett vorteil-etikett--kontur">−' + esc(geld(bj[t.handle], true)) + ' ' + esc(block.getAttribute('data-oz-bundle-titel') || '') + '</span>' : '')
          +   '</span></span>'
          + '<span class="oz__preis">' + zeilenpreis(t, bj[t.handle] || 0) + '</span>'
          + '</li>';
      }).join('');
      kaufzoneSetzen();
    }

    function platteFragen() {
      var a = auswahl();
      var refs = (a.refs || []).map(String);
      var tisch = a.tisch || null;
      var mein = ++lauf;
      if (!refs.length && !(tisch && (tisch.art || tisch.dicke_cm))) { platte = null; bauen(); return; }
      if (!window.Verstaerkung) { setTimeout(platteFragen, 200); return; }
      var eigen = (Number(block.getAttribute('data-oz-gewicht')) || 0) / 1000;
      window.Verstaerkung.monitorGewicht(proxy(), refs).then(function (mKg) {
        return window.Verstaerkung.pruefe({
          proxy: proxy(), art: (tisch && tisch.art) || '',
          kg: refs.length ? mKg + eigen : 0,
          mountSku: block.getAttribute('data-oz-sku') || ''
        });
      }).then(function (paket) {
        if (mein !== lauf) return;
        platte = (paket && paket.TABLE_REINFORCEMENT) || null;
        bauen();
      }).catch(function () { if (mein === lauf) { platte = null; bauen(); } });
    }

    var urteilLauf = 0;
    function urteilFragen() {
      if (!window.SetupUrteil) { urteil = null; setTimeout(urteilFragen, 200); return; }
      var mein = ++urteilLauf;
      window.SetupUrteil.hole().then(function (stand) {
        if (mein !== urteilLauf) return;
        var f = window.SetupUrteil.fuer(stand, block.getAttribute('data-oz-skus'));
        if (f && f.urteil === 'nein' && block.hasAttribute('data-oz-one')) {
          var k = (stand.kombis || []).filter(function (x) { return x.kind === 'one'; })[0];
          if (k) f = { urteil: 'nein', requires: (k.requires || []).filter(function (r) { return r && r.handle && r.in_shop !== false; }) };
          else f = { urteil: 'nein', requires: [], keinOne: true };
        }
        urteil = f;
        bauen();
      }).catch(function () {});
    }

    document.addEventListener('3idee:passung', function (e) {
      monitore = (((e && e.detail) || {}).monitore || []).filter(Boolean);
      bauen();
    });
    document.addEventListener('finder:auswahl', function () {
      if (!(auswahl().refs || []).length) { monitore = []; urteil = null; }
      urteilFragen();
      platteFragen();
    });

    block.addEventListener('click', function (e) {
      var um = e.target.closest('[data-oz-umstellen]');
      if (um) { umstellen(Number(um.getAttribute('data-oz-umstellen'))); return; }
      if (e.target.closest('[data-oz-i]')) {
        var h = e.target.closest('[data-oz-teil]').getAttribute('data-oz-teil');
        var tt = teile.filter(function (x) { return x.handle === h; })[0];
        var feld = document.querySelector('[data-oz-regel-text]');
        if (feld && tt) feld.textContent = ohneSchwelle(tt.grund);
        return;
      }
      if (e.target.closest('[data-fenster-auf]')) return;
      var z = e.target.closest('[data-oz-teil]');
      if (!z || z.classList.contains('is-aus')) return;
      var t = teile.filter(function (x) { return x.handle === z.getAttribute('data-oz-teil'); })[0];
      if (!t) return;
      var jetzt = !istAn(t);
      if (t.stufe === 'REQUIRED') { if (jetzt) delete aus[t.handle]; else aus[t.handle] = true; }
      else an[t.handle] = jetzt;
      zeichnen();
    });

    function kaufform() {
      var alle = document.querySelectorAll('form[data-type="add-to-cart-form"]');
      for (var i = 0; i < alle.length; i++) if (!alle[i].closest('dialog')) return alle[i];
      return null;
    }
    function kaufknopf() { var f = kaufform(); return f ? f.querySelector('button[type="submit"]') : null; }
    function knopfZiel(k) {
      var ziel = null;
      k.querySelectorAll('span').forEach(function (sp) {
        if (!ziel && sp.children.length === 0 && (sp.textContent || '').trim()) ziel = sp;
      });
      return ziel;
    }
    function knopfUrtext(k) {
      var da = k.getAttribute('data-oz-urtext');
      if (da) return da;
      var ziel = knopfZiel(k);
      var t = ziel ? (ziel.textContent || '').trim() : (k.textContent || '').trim();
      k.setAttribute('data-oz-urtext', t);
      return t;
    }
    function knopfText(k, text) { var z = knopfZiel(k); if (z) z.textContent = text; else k.textContent = text; }
    function preisTraeger() {
      var raus = [];
      var spalten = [document.querySelector('.product-buybox'), block.closest('.product-details')];
      spalten.forEach(function (s) {
        if (!s) return;
        s.querySelectorAll('[ref="priceContainer"]').forEach(function (t) { if (raus.indexOf(t) < 0) raus.push(t); });
      });
      document.querySelectorAll('.sticky-add-to-cart [ref="priceContainer"], sticky-add-to-cart [ref="priceContainer"]')
        .forEach(function (t) { if (raus.indexOf(t) < 0) raus.push(t); });
      return raus;
    }
    function gewaehlte() { return teile.filter(istAn); }

    var konfig = block.getAttribute('data-oz-modus') === 'konfig';
    function kaufzoneSetzen() {
      if (konfig) {
        block.dispatchEvent(new CustomEvent('oz:auswahl', { bubbles: true, detail: { teile: gewaehlte().map(function (t) {
          return { handle: t.handle, variante: t.variante, plan: t.plan, anzahl: t.anzahl, preis: t.preis, rabatt: t.rabatt };
        }) } }));
        return;
      }
      var g = gewaehlte();
      var knopf = kaufknopf();
      if (!g.length) {
        preisTraeger().forEach(function (tr) {
          var eigen = tr.querySelector(':scope > .ost__gesamt');
          if (eigen) eigen.hidden = true;
          tr.classList.remove('ost--eigenpreis');
        });
        if (knopf) knopfText(knopf, knopfUrtext(knopf));
        return;
      }
      preisTraeger().forEach(function (tr) {
        var eigen = tr.querySelector(':scope > .ost__gesamt');
        if (eigen) eigen.hidden = true;
        tr.classList.remove('ost--eigenpreis');
      });
      var stueck = 1;
      g.forEach(function (t) { stueck += t.anzahl; });
      if (knopf) { knopfUrtext(knopf); knopfText(knopf, wort('korb', '%d Artikel hinzufügen').replace('%d', stueck)); }
    }

    function abfangen(e) {
      var g = gewaehlte();
      if (!g.length || !window.WarenkorbLegen) return;
      var f = kaufform();
      if (!f) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var idEl = f.querySelector('[name="id"]');
      var mengeEl = f.querySelector('[name="quantity"]') || document.querySelector('.product-details [name="quantity"]');
      var planEl = f.querySelector('[name="selling_plan"]');
      var haupt = { id: Number(idEl ? idEl.value : block.getAttribute('data-oz-variante')),
                    quantity: Math.max(1, parseInt(mengeEl && mengeEl.value, 10) || 1) };
      if (planEl && planEl.value) haupt.selling_plan = planEl.value;
      var posten = [haupt];
      g.forEach(function (t) {
        var p = { id: t.variante, quantity: t.anzahl };
        if (t.plan) p.selling_plan = t.plan;
        posten.push(p);
      });
      var knopf = kaufknopf();
      if (knopf) knopf.disabled = true;
      window.WarenkorbLegen(posten, function () { if (knopf) knopf.disabled = false; });
    }
    function anbinden() {
      var knopf = kaufknopf();
      if (knopf && !knopf.__oz) { knopf.__oz = true; knopf.addEventListener('click', abfangen, true); }
      var f = kaufform();
      if (f && !f.__oz) { f.__oz = true; (f.closest('product-form-component') || f).addEventListener('submit', abfangen, true); }
    }

    if (!konfig) anbinden();
    block.addEventListener('oz:neu', platteFragen);
    urteilFragen();
    platteFragen();
  });
})();
